<template>
  <div v-if="invoice">
    <div class="full-height float-left invoice">

      <div class="row line mb-5">
        <div class="col-12" v-if="!invoice.header">
          <p class="upc text-center">{{invoice.company.name}}</p>
          <p class="upc text-center">{{invoice.company.address}}, {{invoice.company.post_code}} {{invoice.company.city}}</p>
          <p class="text-center">{{invoice.company.tax_bound ? 'ID za DDV: SI' : 'DAVČNA ŠT.: '}}{{invoice.company.tax_number}}</p>
          <p class="upc text-center text-big">{{invoice.businessUnit.name}}</p>
          <p class="upc text-center" v-if="allPeData">PE: {{invoice.businessUnit.address}} {{invoice.businessUnit.house_number}}{{invoice.businessUnit.house_number_addition}}, {{invoice.businessUnit.post_code}} {{invoice.businessUnit.city}}</p>
        </div>
        <div class="col-12 invoice-header-footer" v-else v-html="invoice.header">
        </div>
      </div>

      <div class="row line mb-5" v-if="invoice.buyerInfo">
        <div class="col-12">
          <p>{{invoice.buyerInfo.name}}</p>
          <p>{{invoice.buyerInfo.address}}</p>
          <p>{{invoice.buyerInfo.post_code}} {{invoice.buyerInfo.city}}</p>
          <p>ID za DDV: {{invoice.buyerInfo.tax_number}}</p>
        </div>
      </div>

      <div class="row line q-mb-md" v-if="invoice.comment">
        <div class="col-12">
          <p v-html="invoice.comment"></p>
        </div>
      </div>

      <div class="row line mb-5">
        <div class="col-12">
          <p class="upc font-weight-bold">Račun: {{invoice.invoiceFullNum}}</p>
          <p>Datum: {{invoice.formattedDate}}</p>
          <p v-if="invoice.service_date">Storitev opravljena: <span class="upc text-bold">{{ serviceDate }}</span></p>
          <p><span>Blagajna: {{invoice.electronic_device_id}}</span><span class="ml-4">Blagajnik: {{invoice.moniker}}</span></p>
          <p v-if="invoice.table_name">MIZA: {{invoice.table_name}}</p>
          <p v-if="invoice.invoiceCopyNumber">Št. kopije: {{invoice.invoiceCopyNumber}}</p>
        </div>
      </div>

      <div class="row line mb-5">
        <div class="col-12">
          <div class="row font-weight-bold">
            <div class="col-2 pr-0">
              Kol
            </div>
            <div class="col-5 px-0">
              Naziv
            </div>
            <div class="col-2 text-center px-0">
              Cena
            </div>
            <div class="col-1 text-center px-0">
              Pop
            </div>
            <div class="col-2 text-right pl-0">
              EUR
            </div>
          </div>

          <div class="row">
            <div class="col-12 py-0 my-2" style="height: 15px; overflow: hidden;">===========================================================================================================================================</div>
          </div>

          <div class="row articles" v-for="article of invoice.articles" :key="article.id">
            <div class="pr-0 col-2">
              {{article.quantity | floatString}}x
            </div>
            <div class="px-0 col-5 upc">
              {{article.invoice_name}}
            </div>
            <div class="px-0 col-2 text-center">
              {{(article.total_amount / article.quantity) | price(2)}}
            </div>
            <div class="px-0 col-1 text-center">
              <span v-if="article.discount">{{article.discount}}%</span>
            </div>
            <div class="pl-0 col-2 text-right">
              {{article.total_amount | price(2)}}
            </div>
          </div>

          <div class="row">
            <div class="col-12 py-0 my-2" style="height: 15px; overflow: hidden;">===========================================================================================================================================</div>
          </div>

          <div class="row" v-if="invoice.discountTotal">
            <div class="col-12 text-right">
                Skupni popust EUR: {{invoice.discountTotal | price}}
            </div>
          </div>
          <div class="row">
            <div class="col-12 text-right">
              Za plačilo EUR: <span class="text-med font-weight-bold">{{invoice.payment_amount | price}}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="row line mb-5" v-if="invoice.taxGroups && invoice.company.tax_bound">
        <div class="col-9">
          <div class="row tax-groups-header">
            <div class="col-12 underline">---------------------------------------------------------------------------------------------------------------------------------------------------------------------------</div>
            <div class="col-12 mb-1">
              <div class="row" style="margin: 0px;">
                <span>DDV%</span>
                <v-spacer />
                <span>Neto</span>
                <v-spacer />
                <span>DDV</span>
                <v-spacer />
                <span>Bruto</span>
              </div>
            </div>
          </div>

          <div class="row" v-for="group of invoice.taxGroups" :key="group.id">
            <div class="col-3">
              {{group.tax_level_value}}
            </div>
            <div class="col-3 text-center">
              {{group.taxable_amount | price(2)}}
            </div>
            <div class="col-3 text-center">
              {{group.tax_amount | price(2)}}
            </div>
            <div class="col-3 text-right">
              {{group.price | price(2)}}
            </div>
          </div>

          <div class="row">
            <div class="col-12 py-0" style="height: 20px; overflow: hidden;">---------------------------------------------------------------------------------------------------------------------------------------------------------------------------</div>
          </div>
        </div>

        <div class="col-3">
        </div>
      </div>

      <div class="row line">
        <div class="col-12">
          <p>Način plačila: <span class="upc font-weight-bold">{{paymentMethod}}</span></p>
          <p v-show="payments.length" v-for="type in payments" :key="type.id">
            {{type.payment_type_name}}: <span class="upc text-bold">{{type.amount.toFixed(2).replace('.', ',')}}</span>
          </p>
          <p v-if="!isCashPayment">TRR: <span class="upc text-bold">{{invoice.company.account_number}}</span></p>
          <p v-if="invoiceLink">VEZA: {{invoiceLink}}</p>
          <p>ZOI: {{invoice.zoi}}</p>
          <p>EOR: {{eor}}</p>
        </div>
      </div>
      <div class="row line text-center">
        <div class="col-12">
          <div class="qrcode" ref="qrcode">
          </div>
        </div>
      </div>
      <div class="row line">
        <div class="col-12 invoice-header-footer" v-if="invoice.footer" v-html="invoice.footer">
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import QRCode from 'qrcode'
import moment from 'moment'

export default {
  props: {
    invoice: {
      required: true,
      type: Object
    }
  },
  computed: {
    isCashPayment () {
      if (this.invoice.paymentMethods) {
        return this.invoice.paymentMethods && this.invoice.paymentMethods[0].print_payment_type === 1
      }
      return this.invoice.payments.find(tpy => tpy.print_payment_type === 1)
    },
    serviceDate () {
      return moment(this.invoice.service_date, ['DD.MM.YYYY', 'DD.MM.YYYYTHH:mm:ss', 'YYYY-MM-DDTHH:mm:ss']).format('DD.MM.YYYY')
    },
    payments () {
      if (this.invoice.payments) {
        return this.invoice.payments
      }
      if (this.invoice.paymentMethods) {
        // console.log('maksne: ', this.receiptFullData.paymentMethods)
        // return this.receiptFullData.paymentMethods
        return []
      }
      return []
    },
    eor () {
      if (this.invoice.registration_system === 1) {
        return ''
      }
      return this.invoice.invoice_id
    },
    paymentMethod () {
      return this.invoice.print_payment_type === 1 ? 'Gotovinsko' : 'Negotovinsko'
    },
    allPeData () {
      return this.invoice.businessUnit.address && this.invoice.businessUnit.house_number && this.invoice.businessUnit.post_code && this.invoice.businessUnit.city
    },
    invoiceLink () {
      if (this.invoice.reversed_invoice) return `${this.invoice.reversed_business_premise_id}-${this.invoice.reversed_electronic_device_id}-${this.invoice.reversed_invoice_number}`
      if (this.invoice.reverse_invoice) return `${this.invoice.reverse_business_premise_id}-${this.invoice.reverse_electronic_device_id}-${this.invoice.reverse_invoice_number}`
      return null
    }
  },
  mounted () {
    // setTimeout(() => {
    this.generateCode()
    // }, 0)
  },
  methods: {
    generateCode () {
      QRCode.toCanvas(this.invoice.qrCodeData, (error, canvas) => {
        if (error) console.error(error)
        canvas.style.height = '90px'
        canvas.style.width = '90px'
        this.$refs.qrcode.appendChild(canvas)
      })
    }
  }
}
</script>

<style lang="scss">
.invoice {
  p {
    margin: 7px !important;
  }
}
</style>

<style lang="scss" scoped>

.invoice {
  width: 400px;
  margin: 0 15px;
  border: 1px solid lightgrey;
  color: black;
  background-color: white;
  font-size: 15px;
  line-height: 15px;

  .col-1, .col-2, .col-3, .col-4, .col-5, .col-6, .col-7, .col-8, .col-9, .col-10, .col-11, .col-12  {
    padding-top: 2px;
    padding-bottom: 2px;
  }

  .text-big {
    font-size: 22px;
    line-height: 26px;
  }
  .text-med {
    font-size: 19px;
    line-height: 22px;
  }
  .qrcode {
    height: 90px;
  }
}
.line {
  padding: 0 10px;
}
.upc {
  text-transform: uppercase;
}
p {
  margin: 0;
}
.tax-groups-header {
  position: relative;
  span {
    background-color: white;
    z-index: 11;
  }
  .underline {
    z-index: 10;
    height: 20px;
    overflow: hidden;
    position: absolute;
    top: 0px;
  }
}
</style>

<style lang="scss">
.invoice-header-footer {
  * {
    margin: 0;
  }
  h2 {
    font-size: 38px;
    // line-height: 38px;
    font-weight: normal;
    letter-spacing: normal;
  }
  h3 {
    font-size: 23px;
    // line-height: 23px;
    font-weight: normal;
    font-stretch: ultra-condensed;
    display: inline-block;
    transform: scale(1, 1.5);
    width: 100%;
  }
}
</style>
